
import {throwError as observableThrowError,  Observable, BehaviorSubject } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '@myenv/environment';

@Injectable()
export class SupportOtaService {
  public apiUrl = environment.apiUrl;
  private httpClient: HttpClient;

  constructor(
    private http: HttpClient,
    private router: Router,
    private handler: HttpBackend
  ) {
    this.httpClient = new HttpClient(handler);
  }
  // private messageSource = new BehaviorSubject(this.sideData);
  // currentMessage = this.messageSource.asObservable();

  onSearchCampaign(type, data, customerId): Observable<any> {
    if (type && data) {
      const token = localStorage.getItem('token');
      const headers = new HttpHeaders({
        'Authorization': 'Bearer ' + token,
      });
      let tempUrl = this.apiUrl + `support/campaign/search?customerId=${customerId}`;
      if (type && data) tempUrl += `&key=${type}&value=${data}`;
      return this.httpClient.get(tempUrl, { headers }).pipe(
        catchError(this.handleError));
    }
  }

  getCounts(campaignId): Observable<any> {
    return this.http.get(this.apiUrl + 'support/campaign/' + campaignId + '/device/count').pipe(
      catchError(this.handleError))
  }

  addCampaign(data): Observable<any> {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this.http.post(this.apiUrl + 'support/campaign', data, { headers }).pipe(
      catchError(this.handleError));
  }

  getAllCampaign(page, customerId): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
    });
    return this.http.get(this.apiUrl + `support/campaign?page=${page}&customerId=${customerId}`, { headers }).pipe(
      catchError(this.handleError));
  }

  getCampaignCount(customerId): Observable<any> {
    return this.http.get(this.apiUrl + `support/campaign/count?customerId=${customerId}`).pipe(
      catchError(this.handleError));
  }

  onSearchFile(data, fileType): Observable<any> {
    // if(data) {
      return this.http.get(this.apiUrl + 'ota/files/search/' + '?key=' + data + '&value=' + fileType).pipe(
        catchError(this.handleError));
    // }
  }

  getSupportOtaFiletype(data): Observable<any> {
    return this.http.get(this.apiUrl + `support/ota/files/fileType/${data}?limit=3000`).pipe(
      catchError(this.handleError));
  }

  getAllSupportOtaFiles(page): Observable<any> {
    return this.http.get(this.apiUrl + 'support/ota/files?page=' + page).pipe(
      catchError(this.handleError));
  }

  uploadXL(data, fileName, fileType, fileVersion, ecuGroup, ecuName): Observable<any> {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
    });
    let tempUrl = this.apiUrl + `support/ota/files/${fileType}/upload?fileName=${fileName}`;
    if (fileVersion) tempUrl += `&fileVersion=${fileVersion}`;
    if (ecuGroup && ecuName) {
      tempUrl += `&ecuGroup=${ecuGroup}&ecuName=${ecuName}`;
    }
    return this.httpClient.post(tempUrl, data, { headers }).pipe(
      catchError(this.handleError));
  }

  // getGroupCounts(customerId) {
  //   let token = localStorage.getItem('token');
  //   const headers = new HttpHeaders({
  //     'Authorization': 'Bearer ' + token
  //   });
  //   return this.http.get(this.apiUrl + `vehicles/group/count?customerId=${customerId}`, {headers})
  //     .catch(this.handleError);
  // }

  // getTagCounts(customerId) {
  //   let token = localStorage.getItem('token');
  //   const headers = new HttpHeaders({
  //     'Authorization': 'Bearer ' + token
  //   });
  //   return this.http.get(this.apiUrl + `vehicles/tag/count?customerId=${customerId}`, {headers})
  //     .catch(this.handleError);
  // }

  deleteOta(fileId): Observable<any> {
    return this.http.delete(this.apiUrl + "ota/files/" + fileId).pipe(
      catchError(this.handleError))
  }

  getFilesCount(): Observable<any> {
    return this.http.get(this.apiUrl + "ota/files/count").pipe(
      catchError(this.handleError))
  }

  getFileDetails(fileId): Observable<any> {
    return this.http.get(this.apiUrl + 'ota/files/' + fileId).pipe(
      catchError(this.handleError));
  }

  editUsersVisibility(fileId, userIds): Observable<any> {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      // 'Content-Type': 'multipart/form-data'
    });
    let tempUrl = this.apiUrl + 'ota/files/' + fileId + '/visibility';
    if (userIds.length) {
      tempUrl += "?userIds=" + userIds;
    }
    return this.http.put(tempUrl, headers).pipe(
      // return this.http.put(this.apiUrl +'ota/files/'+fileId+'/visibility?userIds='+ userIds, headers)
      catchError(this.handleError));
  }

  handleError(error: any | any) {
    return observableThrowError(error.error || error || 'Server error');
  }

  editfile(data, fileId): Observable<any> {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
    });
    let tempUrl = this.apiUrl + `campaigns/ota/files/${fileId}`;
    return this.httpClient.put(tempUrl, data, { headers }).pipe(
      catchError(this.handleError));
  }
}
